import { render } from "./ServicesPage.vue?vue&type=template&id=21b377a6"
import script from "./ServicesPage.vue?vue&type=script&lang=js"
export * from "./ServicesPage.vue?vue&type=script&lang=js"

import "./ServicesPage.vue?vue&type=style&index=0&id=21b377a6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__